// --------------------------------------------------------------------------
// Reinitialise modules utility
// --------------------------------------------------------------------------
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (modules) {
    for (var i = 0; i < modules.length; i++) {
        var Module = modules[i].module;

        var moduleName = $('[data-behavior~="' + modules[i].name + '"]');

        if (moduleName.length > 0) {
            var context = moduleName;
            var module = new Module({
                context: context
            });
            module.init();
        }
    }

    return true;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/reinit-modules.js
// module id = 20
// module chunks = 0